import { CircularProgress, FormControl, TextField } from "@mui/material";
import React, {
  useEffect,
  useState,
  forwardRef,
  useImperativeHandle,
} from "react";
import { useSnackbar } from "notistack";
import { makeStyles } from "@mui/styles";
import { DragDropContext, Droppable } from "react-beautiful-dnd";
import moment from "moment";
import {
  add_program_workout_api,
  update_program_workout_api,
} from "src/DAL/programmeWorkout/programmeWorkout";
import WorkoutExercisesUI from "./WorkoutExercisesUI";
import WorkoutExercisesAnswerUI from "./WorkoutExercisesAnswerUI";
import { Icon } from "@iconify/react";
import { get_root_value } from "src/utils/domUtils";
import {
  exercise_obj,
  extra_workout_exercise,
  formatExercises,
  formatSubExercises,
  generateExerciseArray,
  handleScrollCalled,
  paceFromVdot,
} from "src/utils/constants";
import FoodMattersAndMindsetUI from "./FoodMattersAndMindsetUI";
import { memberRewardDetail } from "src/DAL/Profile/Profile";
import VideoUI from "./VideoUI";
import { s3baseUrl } from "src/config/config";
import WorkoutCalendervideoModel from "./component/WorkoutCalendervideoModel";
import UpdateQueList from "./component/UpdateQueList,";

const useStyles = makeStyles(() => ({
  loading: {
    marginLeft: "50%",
    marginTop: "20%",
  },
  customInput: {
    "& .MuiOutlinedInput-root": {
      borderRadius: "0px",

      "& fieldset": {
        border: "none",
      },
    },
  },
}));

const findPaceObjectByVdot = (vdotValue) => {
  return paceFromVdot.find((paceObject) => paceObject.vdot == vdotValue);
};

const AddWorkoutCalender = forwardRef((props, ref) => {
  const vdot33Object = findPaceObjectByVdot(
    props?.member_vdot ? props?.member_vdot : null,
  );
  const [practiceType, setPracticeType] = useState(props.practice_type);
  const [coinpracticeType, setCoinPracticeType] = useState(props.practice_type);
  const [isNotOpen, setIsNotOpen] = useState(true);
  const [isWorkoutCompleted, setIsWorkoutCompleted] = useState(false);
  const [comment, setCommnet] = useState("");
  const [adminComment, setAdminCommnet] = useState("");
  const [oldImage, setOldImage] = useState();
  const [addArray, setaddArray] = useState([{ ...exercise_obj() }]);
  const [original, setOrignial] = useState();
  const [addArrayExtra, setaddArrayExtra] = useState([]);
  const { enqueueSnackbar } = useSnackbar();
  const [isLoading, setIsLoading] = useState(false);
  const [workoutTitle, setWorkoutTitle] = useState("");
  const [complateWorkBook, setComplateWorkBook] = useState(false);
  const classes = useStyles();
  const [memberRewardData, setMemberRewardData] = useState({});
  const [workoutDescription, setWorkoutDescription] = useState("");
  const [modalOpen, setModalOpen] = useState(false);
  const [inputs, setInputs] = useState({
    video_url: "",
    image: "",
    is_completed: false,
  });

  const handleAdd = () => {
    props.setModalChangeExe(true);
    let list = addArrayExtra;
    list.splice(addArrayExtra.length, 0, {
      ...extra_workout_exercise,
    });
    setaddArrayExtra([...list]);
  };

  useImperativeHandle(ref, () => ({
    childButtonClick() {
      handleSubmit();
    },
    childButtonClick2() {
      handleSubmit().then((formDataObject) => {
        if (formDataObject) props.setWorkoutAsTem(formDataObject);
      });
    },
    childButtonClickUpdate() {
      handleSubmitUpdate();
    },
  }));

  function handleOnDragEnd(result) {
    const items = Array.from(addArray);
    const [reorderedItem] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, reorderedItem);
    setaddArray(items);
  }

  const handleSubmit = async (e) => {
    if (e) e.preventDefault();
    setIsLoading(true);
    props.setIsLoading(true);

    const { exerciesArray, isError } =
      practiceType === "video" || practiceType === "workbook"
        ? { exerciesArray: [], isError: false }
        : generateExerciseArray(fullArray, enqueueSnackbar, true);

    if (isError) {
      setIsLoading(false);
      props.setIsLoading(false);
      return;
    }
    const formDataObject = {
      title: workoutTitle,
      workout_type: null,
      description: workoutDescription,
      status: true,
      exercises: exerciesArray,
      program_id: props.programme?._id,
      workout_day: props.day ? props?.day : 1,
      workout_date: moment(props.date).format("YYYY-MM-DD"),
      comment: comment,
      practice_type: practiceType,
    };

    if (practiceType == "food") {
      formDataObject.meals = props?.editData?.meals || [];
      formDataObject.target_day = props?.editData?.target_day || "";
    }

    const result = await add_program_workout_api(formDataObject);
    if (result.code === 200) {
      props?.reloadList();
      setIsLoading(false);
      props.setIsLoading(false);
      props.setOpen(false);
      enqueueSnackbar(result.message, { variant: "success" });
      return formDataObject;
    } else {
      setIsLoading(false);
      props.setIsLoading(false);
      enqueueSnackbar(result.message, { variant: "error" });
    }
  };

  const handleSubmitUpdate = async (e, value_data) => {
    if (!e) setIsLoading(true);
    props.setIsLoading(true);

    let fullArray = [...addArray, ...addArrayExtra];

    const { exerciesArray, isError } =
      practiceType === "video" || practiceType === "workbook"
        ? { exerciesArray: [], isError: false }
        : generateExerciseArray(fullArray, enqueueSnackbar, true);

    if (isError) {
      setIsLoading(false);
      props.setIsLoading(false);
      return;
    }

    const formDataObject = {
      _id: props?.editData?._id,
      exercises: exerciesArray,
      comment: comment,
      library_type: props?.editData?.library_type,
      questions: props?.questionsToSend,
      workout_date: moment(props?.editData?.workout_date).format("YYYY-MM-DD"),
      type: practiceType == "video" ? "video" : "general",
      practice_type: practiceType,
      program_id: props?.editData?.program_info?.program_id,
      is_completed: value_data ? value_data : inputs?.is_completed,
      video_url: inputs.video_url,
      workbook_completed: value_data ? value_data : complateWorkBook,
      video_thumbnail: inputs.image,
      ...(props.editData?.video_only_type &&
        props.editData?.video_only_type.length > 0 && {
          video_only_type: JSON.stringify(props.editData.video_only_type),
        }),
    };

    if (practiceType == "food") {
      formDataObject.meals = props?.editData?.meals || [];
      formDataObject.target_day = props?.editData?.target_day || "";
    }

    const result = await update_program_workout_api(formDataObject);
    if (result.code === 200) {
      enqueueSnackbar(result.message, { variant: "success" });
      props.setModalChangeExe(false);
      props?.setEditWorkputData(result?.workout);
      const workout = result?.workout;
      let newData = {
        ...workout,
        title: workout.title ? workout.title : "",
        color: workout.program_info?.color,
        workout_color: workout.program_info?.color,
        workout_title: workout.title ? workout.title : "",
        workout_exercises: workout.exercises,
        workout_program: workout.program_info,
        workout_completed: workout.workout_completed,
        status: workout.status,
        date: moment(workout.workout_date).format("YYYY-MM-DD"),
        index: props?.editData?.index,
        open: true,
        editable: false,
      };

      let updatedEvents;
      if (props.editData.workout_id) {
        updatedEvents = props.events.map((event) => {
          if (event.workout_id) {
            if (event.workout_id === props.editData.workout_id) {
              return newData;
            }
          }
          return event;
        });
      } else {
        updatedEvents = props.events.map((event) => {
          if (event._id) {
            if (event._id === props.editData._id) {
              return newData;
            }
          }
          return event;
        });
      }
      let list = [...props?.events];

      list[props?.editData?.index] = newData;
      props?.setEvents(updatedEvents);
      handleScrollCalled(workout?._id);

      setIsLoading(false);
      props.setIsLoading(false);
      return formDataObject;
    } else {
      setIsLoading(false);
      props.setIsLoading(false);
      enqueueSnackbar(result.message, { variant: "error" });
    }
  };

  const getMemberRewardDetail = async () => {
    const result = await memberRewardDetail();
    if (result.code === 200) {
      setMemberRewardData(result?.reward_points);
    } else {
      enqueueSnackbar(result.message, { variant: "error" });
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getMemberRewardDetail();
  }, []);

  useEffect(() => {
    if (props?.editData && isNotOpen) {
      setIsWorkoutCompleted(props?.editData?.workout_completed);
      setComplateWorkBook(props?.editData?.workout_completed);
      setOldImage(props?.editData?.video_thumbnail?.thumbnail_1);
      setInputs({
        ...inputs,
        ["video_url"]: props?.editData?.video_url,
        ["is_completed"]: props?.editData?.is_completed,
        ["image"]: props?.editData?.video_thumbnail,
      });
      setCoinPracticeType(
        props?.editData?.program_info?.program_type == "video"
          ? "program_video"
          : props?.editData?.practice_type
          ? props?.editData?.practice_type
          : "workout",
      );
      setPracticeType(
        props?.editData?.practice_type
          ? props?.editData?.practice_type
          : "workout",
      );
      setWorkoutTitle(
        props?.editData?.workout_title
          ? props?.editData?.workout_title
          : props?.editData?.title,
      );
      setWorkoutDescription(props?.editData?.description);
      setCommnet(props?.editData?.comment);
      setAdminCommnet(props?.editData?.admin_comment);

      const givenExercise = formatExercises(
        props?.editData?.exercises,
        props?.member_vdot,
        vdot33Object,
      );

      const givenExerciseExtra = formatSubExercises(
        props?.editData?.exercises,
        true,
        props?.member_vdot,
        vdot33Object,
      );

      setaddArray(givenExercise);
      setOrignial(JSON.parse(JSON.stringify(givenExercise)));
      setaddArrayExtra(givenExerciseExtra);
      setIsNotOpen(false);
    }
  }, [props?.editData]);

  if (isLoading === true) {
    return <CircularProgress className={classes.loading} color="primary" />;
  }

  return (
    <div className="container-fluid">
      {modalOpen && (
        <WorkoutCalendervideoModel
          onOpen={modalOpen}
          setOnOpen={setModalOpen}
          url={inputs?.video_url}
        />
      )}
      <div className=" ">
        <div className="row">
          <div className="col-sm-12 col-md-9 col-lg-10">
            <FormControl className={classes.customInput} sx={{ width: "100%" }}>
              <h2>{workoutTitle}</h2>
            </FormControl>
            <FormControl fullWidth className={classes.customInput}>
              <p>{workoutDescription}</p>
            </FormControl>
          </div>
          <div
            className="col-sm-12 col-md-3 cursor col-lg-2 d-flex justify-content-center "
            style={{
              position: "relative",
            }}
          >
            {practiceType != "video" && oldImage ? (
              <>
                <img
                  className="image-border img-fluid rounded"
                  src={s3baseUrl + oldImage}
                  onClick={() => {
                    setModalOpen(true);
                  }}
                />
                <div className="overlay-icon">
                  <Icon
                    onClick={() => {
                      setModalOpen(true);
                    }}
                    style={{ height: "50px", width: "50px" }}
                    icon={"lets-icons:video-fill"}
                    className="workout-type-icon-container"
                  />
                </div>
              </>
            ) : (
              ""
            )}
          </div>
        </div>
        <DragDropContext
          onDragEnd={handleOnDragEnd}
          className="h-100"
          isDragDisabled={true}
        >
          <Droppable droppableId="characters" isDragDisabled={true}>
            {(provided) => (
              <div
                className="characters"
                {...provided.droppableProps}
                ref={provided.innerRef}
              >
                {practiceType == "workout" ? (
                  <WorkoutExercisesAnswerUI
                    addArray={addArray}
                    setaddArray={setaddArray}
                    setModalChangeExe={props.setModalChangeExe}
                    original={original}
                    practiceType={coinpracticeType}
                    isWorkoutCompleted={isWorkoutCompleted}
                    setIsWorkoutCompleted={setIsWorkoutCompleted}
                    memberRewardData={memberRewardData}
                    handleSubmit={handleSubmitUpdate}
                    member_vdot={props?.member_vdot}
                  />
                ) : practiceType == "video" || practiceType == "comment" ? (
                  <VideoUI
                    inputs={inputs}
                    setInputs={setInputs}
                    setModalChangeExe={props.setModalChangeExe}
                    setIsWorkoutCompleted={setIsWorkoutCompleted}
                    practiceType={coinpracticeType}
                    handleSubmit={handleSubmitUpdate}
                    comment_data={props}
                  />
                ) : practiceType == "workbook" ? (
                  <UpdateQueList
                    questions={props.questionsToSend}
                    setQuestions={props.setQuestionsToSend}
                    editShow={props.editShow}
                    setEditShow={props.setEditShow}
                    mainindex={0}
                    complateWorkBook={complateWorkBook}
                    setComplateWorkBook={setComplateWorkBook}
                    setModalChangeExe={props.setModalChangeExe}
                    practiceType={coinpracticeType}
                    isWorkoutCompleted={isWorkoutCompleted}
                    handleSubmit={handleSubmitUpdate}
                  />
                ) : (
                  <FoodMattersAndMindsetUI
                    addArray={addArray}
                    setaddArray={setaddArray}
                    setModalChangeExe={props.setModalChangeExe}
                    mainindex={0}
                    isWorkoutCompleted={isWorkoutCompleted}
                    setIsWorkoutCompleted={setIsWorkoutCompleted}
                    practiceType={coinpracticeType}
                    memberRewardData={memberRewardData}
                    handleSubmit={handleSubmitUpdate}
                    meals_data={props}
                  />
                )}
                {addArrayExtra.length > 0 && (
                  <>
                    <div className="container-fluid my-4">
                      <h2>
                        <Icon icon="mdi:bicycle-electric" /> Extra work
                      </h2>
                      These exercises aren’t part of the original workout
                    </div>
                    <WorkoutExercisesUI
                      addArray={addArrayExtra}
                      setaddArray={setaddArrayExtra}
                      setModalChangeExe={props.setModalChangeExe}
                      memberRewardData={memberRewardData}
                    />
                  </>
                )}
                {practiceType == "workout" && (
                  <div className="text-start  my-4">
                    <button
                      className="small-contained-button "
                      onClick={() => {
                        handleAdd();
                      }}
                    >
                      Add Extra Work
                    </button>
                  </div>
                )}
                {practiceType !== "comment" && (
                  <>
                    {adminComment ? (
                      <div className="container-fluid">
                        <div
                          className=" my-3"
                          style={{
                            whiteSpace: "break-spaces",
                            fontSize: 14,
                            opacity: 0.7,
                            color: "black",
                          }}
                        >
                          <span
                            style={{
                              opacity: 1,
                              fontWeight: "bold",
                              display: "block",
                              color: get_root_value("--portal-theme-primary"),
                            }}
                          >
                            Comment
                          </span>
                          <div className="ms-0">{comment}</div>
                        </div>
                      </div>
                    ) : (
                      <div className=" my-2">
                        <TextField
                          id="outlined-basic"
                          size="small"
                          variant="outlined"
                          placeholder="Add Comment here!"
                          label="Comment"
                          type="number"
                          value={comment}
                          name="description"
                          multiline
                          rows={5}
                          onChange={(e) => setCommnet(e.target.value)}
                          InputLabelProps={{
                            shrink: true,
                            style: { fontSize: "14px" },
                          }}
                          InputProps={{
                            style: { fontSize: "14px" },
                            readOnly: adminComment,
                          }}
                          sx={{
                            borderRadius: "5px",
                            mt: 2,
                            width: "100%",
                          }}
                        />
                      </div>
                    )}
                    {adminComment && (
                      <div className="container-fluid">
                        <div
                          className=" my-3"
                          style={{
                            whiteSpace: "break-spaces",
                            fontSize: 14,
                            opacity: 0.7,
                            color: "black",
                          }}
                        >
                          <span
                            style={{
                              opacity: 1,
                              fontWeight: "bold",
                              display: "block",
                              color: get_root_value("--portal-theme-primary"),
                            }}
                          >
                            Reply
                          </span>
                          <div className="ms-0">{adminComment}</div>
                        </div>
                      </div>
                    )}
                  </>
                )}
              </div>
            )}
          </Droppable>
        </DragDropContext>
      </div>
    </div>
  );
});
export default AddWorkoutCalender;
